
const INIT_STATE = {
    corporateAccountsList: [],
    initialValues: null,
    success: false,
    error: false,
    corporateAccountSpinner: false,
    invite_Modal: false,
    textMessage: '',
    shouldClearForm: false,
    addingCorporateAccount : false,
    resetPasswordModalVisible : false,
    resetPasswordSpinner : false

}
export default (state = INIT_STATE, action) => {
    switch (action.type) {



        case 'editCorporateAccount_SUCCESS': {
            const updatedRecord = getUpdatedRecord(state.corporateAccountsList, action.payload.Record);
            return {
                ...state,
                corporateAccountsList: [...updatedRecord],
                success: true,
                textMessage: "edit done successfully",
                invite_Modal: false,
                shouldClearForm: true,
                initialValues: null,
                addingCorporateAccount :false
            }
        }
        case 'reset_corporateAccount_States': {
            return {
                ...state,
                success: false,
                error: false,
                corporateAccountSpinner: false,
                shouldClearForm: true,
                textMessage: ''
            }
        }



        default:
            return state
    }
}

const  getUpdatedRecord = (oldData, newData) => {
    let newArray = [];
    oldData.map(Item => {
        if (Item._id === newData._id) {
            newArray.push(newData)
        } else {
            newArray.push(Item);
        }
        return Item
    })
    return newArray;
}
